module.exports = __webpack_public_path__ + "static/media/sub05.9dbdcc74.png";